const DIALOG_CREATE = 'DIALOG_CREATE';
const DIALOG_DESTROY = 'DIALOG_DESTROY';
const DIALOG_UPDATE = 'DIALOG_UPDATE';

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    byId: state => id => state.items.find(dialog => dialog.id === id),
    opened: state => state.items.find(dialog => dialog.visible),
  },
  actions: {
    create({ commit }, payload) {
      commit(DIALOG_CREATE, payload);
    },
    destroy({ commit }, payload) {
      commit(DIALOG_DESTROY, payload);
    },
    open({ commit, getters }, payload) {
      const dialog = { ...getters.byId(payload) };
      dialog.visible = true;
      commit(DIALOG_UPDATE, dialog);
    },
    close({ commit, getters }, payload) {
      let dialog;
      if (payload) {
        dialog = { ...getters.byId(payload) };
      } else {
        dialog = { ...getters.opened };
      }
      dialog.visible = false;
      commit(DIALOG_UPDATE, dialog);
    },
  },
  mutations: {
    [DIALOG_CREATE](state, payload) {
      state.items = [...state.items, payload];
    },
    [DIALOG_DESTROY](state, payload) {
      state.items = state.items.filter(dialog => dialog.id !== payload);
    },
    [DIALOG_UPDATE](state, payload) {
      state.items = state.items.map(dialog => (dialog.id === payload.id ? Object.assign({}, dialog, payload) : dialog));
    },
  },
};
